import axios from "axios";
import { NOMINATIM_URL } from "../const";


const NominatimClient = axios.create({
    baseURL: NOMINATIM_URL,
    // headers: {
    //     'Access-Control-Allow-Origin': '*'
    // }
});

export const nominatimSearch = (state, city, value, geo) => {
    const params = new URLSearchParams({
      state: state || '',
      city: city || '',
      value: value || ''
    });
    // geo = "lat,lon" (живое GPS пользователя) — бэк смещает и сортирует подсказки
    // по близости к этой точке, чтобы «Школьная» показывала ближнюю, а не Омск.
    if (geo) {
      const [lat, lon] = String(geo).split(',');
      if (lat && lon) {
        params.set('lat', lat.trim());
        params.set('lon', lon.trim());
      }
    }
    return NominatimClient.get(`/search?${params.toString()}`);
  };

/** Геокодирование одного выбранного адреса через Yandex (один запрос на выбор). */
export const nominatimGeocode = (address) => {
    const params = new URLSearchParams({ address: address || '' });
    return NominatimClient.get(`/geocode?${params.toString()}`);
  };

export const nominatimReverse = (latitude, longitude) => {
    return NominatimClient.get(
        `/reverse?lat=${latitude}&lon=${longitude}&addressdetails=1&format=json`
    )
}
